import React from 'react';
import { Users } from 'lucide-react';

const RSVPSection = () => (
  <div className="max-w-4xl mx-auto px-6 py-12">
    <div className="text-center mb-16 opacity-0 animate-[fadeInUp_1s_ease-out_0.2s_forwards]">
      <Users className="mx-auto mb-6 text-[#E76C9B]" size={40} />
      <h2 className="text-4xl font-serif font-light text-[#7A3E53] mb-4">RSVP</h2>
      <p className="text-[#5A8E6E] text-lg">Kindly respond by Sunday, 30 November 2025</p>
    </div>

    <div className="bg-white/80 border border-[#F7C843]/30 rounded-2xl shadow-sm p-8 md:p-12 text-center hover:shadow-lg transition-all duration-500 opacity-0 animate-[fadeInUp_1s_ease-out_0.4s_forwards]">
      <h3 className="text-2xl font-serif font-light text-[#7A3E53] mb-6 opacity-0 animate-[slideInDown_1s_ease-out_0.6s_forwards]">
        We Can't Wait to Celebrate With You!
      </h3>
      <p className="text-[#5A8E6E] mb-8 max-w-lg mx-auto opacity-0 animate-[fadeIn_1s_ease-out_0.8s_forwards]">
        Please let us know if you'll be joining us for our special day.
      </p>

      <div className="mt-12 pt-8 border-t border-[#F29AB3]/20 opacity-0 animate-[fadeInUp_1s_ease-out_1s_forwards]">
        <h4 className="font-serif text-[#7A3E53] mb-4">Please RSVP via Joy:</h4>

        <a
          href="https://withjoy.com/megan-and-greg-feb-26"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="w-auto bg-[#7A3E53] text-white py-3 px-6 rounded-full hover:bg-[#7A3E53]/90 hover:shadow-md transition-all duration-300 font-serif tracking-wide"
          >
            RSVP Here
          </button>
        </a>
      </div>
    </div>
  </div>
);

export default RSVPSection;